//*react- recursos
import React, { useEffect } from "react";

//*archivos
import tuplacatalogo from "../stores/tuplacatalogoStore";

//*interfaces
interface PropsCT{
  catalogo:any;
}

//*componente
export default function ConvierteCatalogoATupla(props: PropsCT){
  const { setCatalogoTupla} =
  tuplacatalogo((state:any) =>( {
    setCatalogoTupla: state.setCatalogoTupla,
  }));

  useEffect(()=>{
    let tuplaTemp:any={};
    props.catalogo.map((c:any)=>{
      let valuesC= Object.values(c);
      let id:any= valuesC[0];
      tuplaTemp[id]= valuesC[1];
    })
    setCatalogoTupla(tuplaTemp);
    //console.clear();
    console.log("** ConvierteCatalogoATupla **");
    console.log("catálogo de entrada: ", props.catalogo);
    console.log("tupla de salida: ", tuplaTemp);
  },[]);
    
  return (
       <>
           <label className="container">
             *Consulte la consola
           </label>
       </>

  )
}